import {
  Box,
  Flex,
  Spacer,
  Image,
  Text
} from '@chakra-ui/react'
import { useRouter } from 'next/router'


const Error = ({ type }) => {
  const router = useRouter()
  /*
    需要額外聯絡業務來開放試玩
    原廠的測試環境會在天數內，自動註銷玩家帳號

    DB彩票：7天
    DB真人：14天

    需向原廠重新申請、請後端處理註冊資料
    流程與規格：https://docs.goldenf.vip/books/hello-demo-JcL/page/20240110
  */
  const contactBusiness = ['ybkeno', 'yblive']
  // 判断 router.query.vendor 是否包含在 contactBusiness 陣列裡
  const needToContactText = contactBusiness.includes(router?.query?.vendor) ? '若需试玩，请联络业务申请' : null;


  const errorList = {
    'launch-error': {
      title: 'error',
      img: 'LaunchError.svg',
      desc: '游戏无法开启  将跳转回上一页'
    },
    'game-not-found': {
      title: 'error',
      img: 'GameNotFound.svg',
      desc: '找不到游戏'
    },
    'no-trial': {
      title: 'SORRY',
      img: 'NoGame.svg',
      desc: '此产品商不提供试玩游戏'
    },
    'no-game': {
      title: 'SORRY',
      img: 'NoGame.svg',
      desc: '此产品商没有新增游戏'
    },
  }

  return (
    <Flex
      flexDir={'column'}
      alignItems={'center'}
      justify={'center'}
    >
      <Image
        width='150px'
        height='150px'
        src={`/static/error/${errorList[type]?.img}`}
        alt='Error'
      />

      <Text
        as='div'
        color={'#FFCD44'}
        fontSize={'32px'}
        lineHeight={'46px'}
        fontWeight={'700'}
      >
        {/* 發生錯誤 */}
        {errorList[type]?.title}
        
      </Text>
      <Text
        as='span'
        fontSize={'md'}
        color={'#979797'}
      >
        {errorList[type]?.desc}
        {/* 游戏无法开启  将跳转回上一页 */}
      </Text>

      {needToContactText && (
        <Text
          as='span'
          fontSize={'md'}
          color={'#979797'}
        >
          {needToContactText}
        </Text>
      )}
    </Flex>
  )
}

export default Error